<script>
import {getStations} from '@/api';
import AdminMinx from '@/mixins/admin';
import {pageIsFinish} from '@/libs/util';
import {List, PullRefresh, Cell, Search} from 'vant';
import Config from "@/config";

export default {
  mixins: [
    AdminMinx
  ],
  components: {
    [PullRefresh.name]: PullRefresh,
    [Search.name]: Search,
    [List.name]: List,
    [Cell.name]: Cell
  },
  data() {
    return {
      page: 1,
      keyword: null,
      stations: [],
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  methods: {
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.loadData();
    },
    loadData() {
      if (this.refreshing) {
        this.stations = [];
        this.refreshing = false;
      }

      this.loading = true;
      getStations({keyword: this.keyword, page: this.page, pageSize: Config.pageSize}).then(response => {
        this.stations = this.page === 1 ? response.data.body.data : this.stations.concat(response.data.body.data);
        this.finished = pageIsFinish(response.data.body);
        this.page = response.data.body.page + 1;
      }).finally(() => this.loading = false).catch(() => this.finished = true);
    },
    toMaintain(stationCode) {
      this.$router.push({name: 'adminMaintain', params: {stationCode}});
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-search v-model="keyword" @search="onRefresh" shape="round" background="#009251" placeholder="搜索站点名称"/>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData">
      <van-cell v-for="item in stations" :key="item.code" :title="item.name" @click="toMaintain(item.code)"/>
    </van-list>
  </van-pull-refresh>
</template>

<style scoped>

</style>